import React from 'react';
import UploadShorts from '../../Components/UploadShorts/UploadShorts';
import Sidebar from '../../Components/Sidebar/Sidebar';
import Header from '../../Components/Header/Header';
import DashboardRightSection from '../../Components/DashboardRightSection/DashboardRightSection';
import Chatbot from '../../Components/Chatbot/Chatbot';
import ScrollNav from '../../Components/ScrollNav/ScrollNav';

const UploadShortsPage = () => {
    return (
        <div className="BallotsPage">
            <div className="ballotsPageContainer">
                <div className="headerContain">
                    <Header />
                </div>
                <div className="ballotsPageContainer2">
                    <div className="sidebarContain">
                        <Sidebar />
                    </div>
                    <div className="middleContainer">
                        <UploadShorts />
                    </div>
                    <div className="dashboardRightSectionContain">
                        <DashboardRightSection />
                    </div>
                </div>
                <Chatbot />
                <ScrollNav />
            </div>
        </div>
    )
}

export default UploadShortsPage;